import { UserCampaignAccessTogle } from "./UserCampaignAccessToggle";
import { UserRoleTag } from "../../../../ui-components/UserRoleTag";
import { UserRole } from "../../../../auth/store";

import { CampaignAccessDataUser } from "../../store";
import { useAppSelector } from "../../../../utils/hooks";
import { userList, UserInList } from "../../../../user-management/store";

const computeUserDisplayName = (user: UserInList) =>
  user.firstName ? `${user.firstName} ${user.lastName}` : user.email;
export const UserCampaignAccessWidgetColumns = (toggleUserAccess: any) => {
  const allIterationsFilter = useAppSelector(userList);

  const userFilterData = allIterationsFilter.map((user: UserInList) => {
    const displayValue = computeUserDisplayName(user);
    return { text: displayValue, value: displayValue };
  });

  return [
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      filterSearch: true,
      filters: userFilterData,
      render: (value: string, user: CampaignAccessDataUser) => {
        const displayValue = computeUserDisplayName(user);
        return displayValue;
      },
      onFilter: (value: string, user: CampaignAccessDataUser) =>
        user.email.includes(value) ||
        user.firstName.includes(value) ||
        user.lastName.includes(value),
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (value: string, user: CampaignAccessDataUser) => {
        return <UserRoleTag userRole={value} />;
      },
      filters: [
        { text: "Admin", value: UserRole.ADMIN },
        { text: "Contributor", value: UserRole.CONTRIBUTOR },
      ],
      onFilter: (value: any, record: any) => record.role === value,
    },
    {
      title: "Access",
      key: "actions",
      render: (value: string, record: CampaignAccessDataUser) => {
        return (
          <UserCampaignAccessTogle
            user={record}
            toggleUserAccess={toggleUserAccess}
          />
        );
      },
    },
  ];
};
